import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./ApproveCandidates.css";
// import CareerJourneyFlow from "./career_journey/CareerJourneyFlow";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { X } from "lucide-react";

const CandidateSchedules = () => {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const response = await fetch(
        `${
          process.env.REACT_APP_API_URL || "http://localhost:3500"
        }/api/admin/candidate-schedules`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch candidate schedules");
      }

      const data = await response.json();
      setSchedules(data);
    } catch (error) {
      setError("Failed to fetch candidate schedules");
      console.error("Error fetching schedules:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatTime = (time) => {
    if (!time) return "";
    // time is in HH:mm:ss, so create a date and get the time part
    const d = new Date(`1970-01-01T${time}`);
    return d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleViewDetails = (schedule) => {
    navigate(`/career-journey/${schedule.userId}`);
  };

  const formatDateTimeDDMMYYYY = (value) => {
    if (value == null || value === "") return "Date Not Provided";

    const date = new Date(value);
    if (isNaN(date.getTime())) return String(value);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");

    return `${dd}/${mm}/${yyyy} , ${hh}:${min}`;
  };

  if (loading) {
    return (
      <div className="main-content">
        <div className="container">
          <div className="loading-spinner">Loading candidate schedules...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* <ToastContainer /> */}
      <div className="main-content">
        <div className="container">
          <div className="page-header">
            <Link
              to="/"
              className="back-link"
              style={{ marginTop: "1rem", marginBottom: "0.5rem" }}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
              Back to Dashboard
            </Link>
            <div className="title-container">
              <h1 className="page-title">Candidate Discussion Schedules</h1>
            </div>
            <div style={{ width: "180px" }}></div>
          </div>

          {error && <div className="error-message">{error}</div>}

          {schedules.length === 0 ? (
            <div className="empty-state">
              <h3>No upcoming schedules found</h3>
              <p>
                There are currently no future candidate discussion schedules.
              </p>
            </div>
          ) : (
            <div className="schedule-table-container">
              <table className="schedule-table">
                <thead>
                  <tr>
                    <th>Candidate Name</th>
                    <th>Email</th>
                    {/* <th>Date & Time</th> */}
                    <th>Scheduled On</th>
                    {/* <th>Scheduling link</th> */}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {schedules.map((schedule) => (
                    <tr key={schedule.id}>
                      <td>
                        <div className="candidate-name">
                          {schedule.firstName && schedule.lastName
                            ? `${schedule.firstName} ${schedule.lastName}`
                            : "Unnamed Candidate"}
                        </div>
                      </td>
                      <td>{schedule.email}</td>
                      {/* <td>
                        <div className="schedule-datetime">
                          <div className="schedule-date">
                            <strong>{formatDate(schedule.date)}</strong>
                          </div>
                          <div className="schedule-time">
                            <strong>{formatTime(schedule.time)}</strong>
                          </div>
                        </div>
                      </td> */}
                      <td>{formatDateTimeDDMMYYYY(schedule.createdAt)}</td>
                      {/* <td>
                        {schedule.cjExists ? (
                          "Interview completed"
                        ) : schedule.meeting_link ? (
                          <a href={schedule.meeting_link} target="_blank">
                            {schedule.meeting_link}
                          </a>
                        ) : (
                          "Not provided"
                        )}
                      </td> */}
                      <td>
                        <button
                          className={`career-journey-details-btn btn-sm ${
                            schedule.cjExists ? "btn-update" : "btn-create"
                          }`}
                          onClick={() => handleViewDetails(schedule)}
                        >
                          {schedule.cjExists
                            ? "Update Career Journey"
                            : "Create Career Journey"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CandidateSchedules;
